import Breadcrumb from "./Breadcrumb";

import styles from "./Breadcrumbs.module.scss";

import useMediaQuery from "@/helpers/hooks/useMediaQuery";

export default function Breadcrumbs({ breadcrumbList }) {
  const isMobileOrTablet = useMediaQuery("(max-width: 1024px)"); // Currently breadcrumbs are displayed only on desktop
    // Filter out breadcrumbs with "Your bag" or "Information"
    const filteredBreadcrumbList = breadcrumbList?.filter(
      (crumb) =>
        crumb.text !== "Your bag" &&
        crumb.text !== "Information"
    );

  if (!isMobileOrTablet) {
    return (
      (filteredBreadcrumbList.length > 0) ? <section className={`${styles.breadcrumb_sec}`}>
        {(filteredBreadcrumbList && filteredBreadcrumbList.length > 0) ?
          <div className="container-fluid mw-1440">
            <div className="row">
              <nav className="grid-md-12 grid-sm-12" aria-label="breadcrumbs">
                <ol>
                  {filteredBreadcrumbList.map((crumb, index) => {
                    return (
                      <Breadcrumb
                        key={index}
                        link={crumb.link}
                        text={crumb.text}
                      />
                    );
                  })}
                </ol>
              </nav>
            </div>
          </div>
        : "" }
      </section> : <div></div>
    );
  }
}
